import React, { createContext, useContext, useState, useMemo, useCallback } from "react";
import { translations } from "@/lib/translations";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window !== "undefined") return localStorage.getItem("rx_lang") || "en";
    return "en";
  });

  const change = useCallback((l) => {
    setLang(l);
    if (typeof window !== "undefined") {
      try { localStorage.setItem("rx_lang", l); }
      catch (e) { console.warn("[LangContext] storage error:", e); }
    }
  }, []);

  // translations is a module-scope constant, so include it explicitly for
  // hook-deps correctness even though it never changes.
  const t = useMemo(() => translations[lang] || translations.en, [lang]);

  const value = useMemo(() => ({ lang, setLang: change, t }), [lang, change, t]);

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
